import React from 'react';
import './panelists.scss';
import Panelist from './Panelist';
import { lang } from '../lang';

function Panelists() {
  const images = [
    'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/asha.jpg',
    'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/fatima.jpg',
    'https://cdn.courageousstudios.com/assets/sponsorcontent/regeneron/willie.jpg'
  ];
  return (
    <div className="panelists">
      {lang.panelists.map((list, i) => {
        return <Panelist data={list} image={images[i]} key={list.name} index={i} />;
      })}
    </div>
  );
}

export default Panelists;
